module.exports = __webpack_public_path__ + "img/banner11.ca3fcc9c.jpg";